import { createAction, props } from '@ngrx/store';
import { Attachment } from '@shared/models';
import { AttachmentParams } from '@shared/services/attachment.service';

export const attachmentsClear = createAction('[Attachments] Clear');

export const attachmentsCreate = createAction(
  '[Attachments] Create',
  props<{
    payload: {
      file: File;
      params: Partial<AttachmentParams>;
      candidateId?: number;
    };
  }>(),
);

export const attachmentsCreateSuccess = createAction(
  '[Attachments] Create Success',
  props<{ payload: Attachment }>(),
);

export const attachmentsCreateFailure = createAction(
  '[Attachments] Create Failure',
  props<{ error: any }>(),
);

export const attachmentsDelete = createAction(
  '[Attachments] Delete',
  props<{ attachmentId: number }>(),
);

export const attachmentsDeleteSuccess = createAction(
  '[Attachments] Delete Success',
  props<{ payload: number }>(),
);

export const attachmentsDeleteFailure = createAction(
  '[Attachments] Delete Failure',
  props<{ error: any }>(),
);

export const attachmentsGetLatestResume = createAction(
  '[Attachments] Load Latest Resume',
  props<{ payload: { candidateId: number; onlyPdfFiles: boolean } }>(),
);

export const attachmentsGetLatestResumeSuccess = createAction(
  '[Attachments] Load Latest Resume Success',
  props<{ payload: Attachment }>(),
);

export const attachmentsGetLatestResumeFailure = createAction(
  '[Attachments] Load Latest Resume Failure',
  props<{ error: any }>(),
);

export const attachmentsGetLatestCoverLetter = createAction(
  '[Attachments] Load Latest CoverLetter',
  props<{ payload: { candidateId: number; onlyPdfFiles: boolean } }>(),
);

export const attachmentsGetLatestCoverLetterSuccess = createAction(
  '[Attachments] Load Latest CoverLetter Success',
  props<{ payload: Attachment }>(),
);

export const attachmentsGetLatestCoverLetterFailure = createAction(
  '[Attachments] Load Latest CoverLetter Failure',
  props<{ error: any }>(),
);

export const attachmentsGetResumes = createAction(
  '[Attachments] Load Resumes',
  props<{ candidateId: number }>(),
);

export const attachmentsGetResumesSuccess = createAction(
  '[Attachments] Load Resumes Success',
  props<{ payload: Attachment[] }>(),
);

export const attachmentsGetResumesFailure = createAction(
  '[Attachments] Load Resumes Failure',
  props<{ error: any }>(),
);

export const attachmentsLoad = createAction(
  '[Attachments] Load',
  props<{ payload: Partial<AttachmentParams> }>(),
);

export const attachmentsLoadSuccess = createAction(
  '[Attachments] Load Success',
  props<{ payload: Attachment[] }>(),
);

export const attachmentsLoadFailure = createAction(
  '[Attachments] Load Failure',
  props<{ error: any }>(),
);

export const attachmentsGet = createAction('[Attachments] Get', props<{ id: number }>());

export const attachmentsGetSuccess = createAction(
  '[Attachments] Get Success',
  props<{ attachment: Attachment }>(),
);

export const attachmentsGetFailure = createAction(
  '[Attachments] Get Failure',
  props<{ error: any }>(),
);
